/* eslint-disable max-len */
import { adminMessages } from './adminMessages';
import { alertsMessages } from './alerts.en.translations';
import { anmTrialMessages } from './anmTrialMessages';
import { commonMessages } from './common.en.translation';
import { dashboardMessages } from './dashboard.en.translations';
import { deploymentGuideMessages } from './deploymentGuideMessages';
import { formTranslations } from './form.en.translations';
import { globalAdminMessages } from './globalAdminMessages';
import { integrationMessages } from './integrationMessages';
import { onboardingMessages } from './onboardingMessages';
import { pathfinderMessages } from './pathfinder.en.translations';
import { reportMessages } from './reportMessages';
import { saasOpsMessages } from './saasOpsMessages';
import { tableViewsMessages } from './tableViewsMessages';
import { tableMessages } from './tablesMessages';
import { tagsMessages } from './tagsMessages';
import { tooltipMessages } from './tooltipsMessages';
import { userInviteMessages } from './userInviteMessages';

const messageList = {
    'Activity.application_add': 'Application Add',
    'Activity.browser_login': 'Browser Login',
    'Activity.download': 'Download',
    'Activity.form_login': 'Form Login',
    'Activity.google_login': 'GWS Login',
    'Activity.id': 'ID: {{id}}',
    'Activity.ip': 'IP: {{ip}}',
    'Activity.microsoftEntraID.login': 'Microsoft Entra ID Login',
    'Activity.sso_google': 'SSO - Google',
    'Activity.sso_microsoft': 'SSO - Microsoft',
    'AddTagModal.title.create': 'Create Tag',
    'AddTagModal.title.edit': 'Edit Tag',
    'Admin.Notes.header_notice':
        'This page allows you to view all notes and recommendations across all of your applications and allows you to mark recommendations as complete.',
    'Admin.Notes.no_results':
        "You have not added any notes or recommendations for this client - Add your first by clicking the icon next to the app’s name in the 'Application' menu.",
    'AdminDigest.approved_applications': 'Approved Applications',
    'AdminDigest.classify_application': 'Classify Application',
    'AdminDigest.classify_applications': 'Classify Applications',
    'AdminDigest.classify_workflow': 'Classify Workflow',
    'AdminDigest.manage_application': 'Manage Application',
    'AdminDigest.manage_applications': 'Manage Applications',
    'AdminDigest.new_applications_title': 'Added Applications',
    'AdminDigest.pending_applications': 'Pending Applications',
    'AdminDigest.ssoInUse': 'In use',
    'AdminDigest.ssoNotInUse': 'Not in use',
    'AdminDigest.ssoSupportedAppsCount': 'of {{count}} Apps',
    'AdminDigest.title': 'Admin Digest',
    'AdminDigest.top_applications': 'Top Application Usage This Month',
    'AdminDigest.total_applications': 'Total Applications Managed',
    'AdminDigest.unapproved_applications': 'Unapproved Applications',
    'AdminDigest.unclassified_applications_title': 'Unclassified Applications',
    'AdminDigest.usage_by_status': 'Usage By Lifecycle Stage',
    'AdminUser.disabled_alert':
        'This user has been disabled and will no longer collect metrics and is unable to login. You may run an offboard report:',
    'AdminUser.run_disabled_user_report': 'Run Offboard Report',
    'AdminView.admin_dashboard': 'Admin Dashboard',
    'AllClientSettings.brand_enabled': 'Branding Enabled',
    'AllClientSettings.PartnerBranding': 'Partner Branding',
    'AllClientSettings.product_name': 'Brand Name',
    'AllClientSettings.removeLogo': 'Remove Logo',
    'AllClientSettings.select_a_logo': 'Brand Logo',
    'AllClientSettings.select_new_logo':
        'Select new logo to upload (.png, .jpg)',
    'AllClientSettings.set_product_name': 'Type Brand Name',
    'AllClientSettings.upload_logo': 'Select a Logo',
    'AllClientSettings.upload_logo_requirements':
        'All images will be resized to a maximum of 170px width and maximum of 50px height. For best results, use images with no whitespace on outside of borders.',
    'AllClientSettings.upload_new_logo': 'Confirm Logo Choice',
    'altText.emptyStateIcon': 'Empty State Panel Icon',
    'AltText.favicon': 'Auvik Favicon',
    'APIKey.generate': 'Generate API Key',
    'APIKey.regenerate': 'Regenerate API Key & Secret',
    'Application.clientsUsing': 'Clients Using This App',
    'Application.contract_alert_view': 'View Contract Details',
    'Application.contractAlertPreText_one':
        'You have an upcoming contract renewal due in 1 day.',
    'Application.contractAlertPreText_other':
        'You have an upcoming contract renewal due in <span style="font-weight:600;">{{count}}</span> days.',
    'Application.contractAlertPreText_zero':
        'The contract renewal date for this application is today.',
    'Application.contractAlertPreTextExpired_one':
        'This contract expired 1 day ago.',
    'Application.contractAlertPreTextExpired_other':
        'This contract expired <span style="font-weight:600;">{{count}}</span> days ago.',
    'Application.create_new_tag': 'Create a new tag',
    'Application.create_tag': 'Create Tags',
    'Application.delete.fail': 'Unable to delete application.',
    'Application.edit_tag': 'Edit Tags',
    'Application.navigateTo': 'Navigate to app page for {{name}}',
    'Application.saveDetails.fail': 'Unable to update application details.',
    'Application.saveDetails.success':
        'Successfully updated application details.',
    'Application.saveName.fail': 'Unable to update application name.',
    'Application.saveName.success': 'Successfully updated application name.',
    'Application.unable_to_load_application_name':
        'Unable to Load Application Name',
    'Application.use_existing_tags': 'Use existing tags',
    'Application.usersUsing': 'Users Using This App',
    'ApplicationContractManagement.alerting': 'Enable subscription alerts',
    'ApplicationContractManagement.alertingPsa':
        'Subscribe Contract Alerts to PSA',
    'ApplicationContractManagement.contractDetails': 'Contract Details',
    'ApplicationContractManagement.contractFinancials': 'Contract Financials',
    'ApplicationContractManagement.contractNotes': 'Contract Notes',
    'ApplicationContractManagement.contractsUpForReviewOn':
        'Contracts up for review on: {{date}}',
    'ApplicationContractManagement.contractType': 'Contract Type',
    'ApplicationContractManagement.daysAlert':
        'Days Before Renewal For Alert To Be Sent',
    'ApplicationContractManagement.enabled': 'Contract management enabled',
    'ApplicationContractManagement.errorDelete':
        'Contract could not be removed.',
    'ApplicationContractManagement.errorSave': 'Contract could not be saved.',
    'ApplicationContractManagement.errorUpdate':
        'Contract could not be updated.',
    'ApplicationContractManagement.monthlyConfiguration':
        'Monthly Configuration Details',
    'ApplicationContractManagement.monthToMonth': 'Month to month contract',
    'ApplicationContractManagement.mrr': 'Monthly-Recurring Charges',
    'ApplicationContractManagement.nrc': 'Non-Recurring Charges',
    'ApplicationContractManagement.renewalDate': 'Day of Month For Renewal',
    'ApplicationContractManagement.renewalDateDayMonth':
        'Day of Month For Renewal',
    'ApplicationContractManagement.renewConfiguration':
        'Renewal Contract Configuration',
    'ApplicationContractManagement.renewDate': 'Renewal contract',
    'ApplicationContractManagement.successSave': 'Contract successfully saved.',
    'ApplicationContractManagement.tcv': 'Total Contract Value',
    'ApplicationContractManagement.title': 'Application Contract Management',
    'ApplicationContractManagement.users': 'Subscribed Users',
    'ApplicationDashboard.admin_application_dashboard': 'Application Library',
    'ApplicationDashboard.application_overview': 'Application Overview',
    'ApplicationDashboard.applicationInventory': 'Application Inventory',
    'ApplicationDashboard.classified': 'Classified',
    'ApplicationDashboard.classified_description':
        'The Managed Applications menu shows applications that have been previously marked with either a lifecycle stage or business owner.',
    'ApplicationDashboard.details.needToClassifyToEdit':
        'Classify the application to enable editing the application details.',
    'ApplicationDashboard.last_calculated': 'Last Calculated <Date />',
    'ApplicationDashboard.last_week_active_users': 'Last Week’s Active Users',
    'ApplicationDashboard.last_weeks_usage': 'Last Week’s Usage',
    'ApplicationDashboard.manage_application_users': 'Manage Application Users',
    'ApplicationDashboard.manage_users': 'Manage Application Users',
    'ApplicationDashboard.managed': 'Managed',
    'ApplicationDashboard.managed_description':
        'Applications are considered managed when they have been added to the system and have a proper business owner assigned for managing the platform and a lifecycle stage other than “Discovered.” To make bulk changes to applications, visit the ',
    'ApplicationDashboard.recently_added_users': 'Recently Added Users',
    'ApplicationDashboard.recentlyDiscoveredApps':
        'All Discovered Applications (Last 30 Days)',
    'ApplicationDashboard.run_reports': 'Run Reports',
    'ApplicationDashboard.unclassified': 'Unclassified',
    'ApplicationDashboard.unmanaged': 'Unmanaged',
    'ApplicationDashboard.unmanaged_description':
        'Applications are considered unmanaged when they have been classified in the system via the Application classification dashboard. These applications are not considered managed until they have a lifecycle stage other than “Discovered” and they have a business owner assigned. To make bulk changes to applications, visit the ',
    'ApplicationDashboard.users.integrationDiscovery':
        'Integration-Based Discovery',
    'ApplicationDashboard.users.saasDiscovery': 'SaaS Management Discovery',
    'ApplicationRemove.description':
        'Deleting this application will remove it from the discovered applications menu, which will also remove it from all reports. If any new usage data is detected for the removed application, it will be automatically re-enabled and appear as a newly discovered app.',
    'ApplicationRemove.remove': 'Remove Application',
    'Applications.classify.meaning':
        'To classify an application, you must specify the lifecycle stage and/or business owner.',
    'Applications.editNumberOfApps_one': 'Edit {{count}} Application',
    'Applications.editNumberOfApps_other': 'Edit {{count}} Applications',
    'Applications.identified_urls': 'Identified URLs',
    'Applications.incidentBanner_one':
        'There is an active {{incidentImpact}} incident that may impact {{count}} user of this application. Click <a href="{{incidentExternalLink}}" target="_blank" rel="noopener noreferrer nofollow" class="link--infoAlert underline"><span style="font-weight:600;">here</span></a> to learn more.',
    'Applications.incidentBanner_other':
        'There is an active {{incidentImpact}} incident that may impact {{count}} users of this application. Click <a href="{{incidentExternalLink}}" target="_blank" rel="noopener noreferrer nofollow" class="link--infoAlert underline"><span style="font-weight:600;">here</span></a> to learn more.',
    'Applications.incidentImpact.critical': 'Critical',
    'Applications.incidentImpact.maintenance': 'Maintenance',
    'Applications.incidentImpact.major': 'Major',
    'Applications.incidentImpact.minor': 'Minor',
    'Applications.incidentImpact.none': 'None',
    'Applications.incidentImpact.unknown': 'Unknown',
    'Applications.incidentsTable.noIncidents':
        'There are no active incidents for this application.',
    'Applications.incidentsTable.title': 'Recent Service Interruptions',
    'Applications.incidentStatus.completed': 'Completed',
    'Applications.incidentStatus.identified': 'Identified',
    'Applications.incidentStatus.in progress': 'In Progress',
    'Applications.incidentStatus.in_progress': 'In Progress',
    'Applications.incidentStatus.investigating': 'Investigating',
    'Applications.incidentStatus.monitoring': 'Monitoring',
    'Applications.incidentStatus.postmortem': 'Postmortem',
    'Applications.incidentStatus.resolved': 'Resolved',
    'Applications.incidentStatus.scheduled': 'Scheduled',
    'Applications.incidentStatus.update': 'Update',
    'Applications.incidentStatus.verifying': 'Verifying',
    'Applications.integration.lastUpdate':
        'Last Integration data update: {{date}}',
    'Applications.recentSaaSServiceInterruptions':
        'Recent SaaS Service Interruptions',
    'Applications.updatingWait': 'Updating applications... Please wait.',
    'appOptions.sendEmail': 'Email',
    'appOptions.title': 'App Confirmation',
    'AuthenticationHandler.logging_in': 'Logging you in.',
    'Banner.getStarted.text':
        'Looking to get started? Click <a href="https://support.auvik.com/hc/en-us/sections/12838724426388-Getting-Started-with-Auvik-SaaS-Management" class="link underline" target="_blank" rel="noopener noreferrer nofollow" data-trackid="topInfoBannerGetStarted"><span style="font-weight:600;">here</span></a> to learn how to deploy your first SaaS data collector via script, RMM, or MDM.',
    'Banner.showMeHowToDeploy.text':
        'We haven’t discovered any SaaS data yet. Learn <a href="https://support.auvik.com/hc/en-us/sections/12838724426388-Getting-Started-with-Auvik-SaaS-Management" class="link underline" target="_blank" rel="noopener noreferrer nofollow" data-trackid="topInfoBannerShowMeHowToDeploy"><span style="font-weight:600;">how to deploy</span></a> your first SaaS data collector via script, RMM, or MDM.',
    'BedrockModal.appName': 'App Name',
    'BedrockModal.appType': 'App Type',
    'BedrockModal.categoryName': 'Category',
    'BedrockModal.description': 'Description',
    'BedrockModal.riskReason': 'Risk Reason',
    'BedrockModal.riskScore': 'Risk Score',
    'BedrockModal.supportPage': 'Support Page',
    'BulkEditor.description':
        'Here you can bulk update applications with different fields. Select a field below to get started, then changes are made instantly as you change them.',
    'BulkEditor.exclude_no_business_owner_required':
        'Exclude Applications with No Business Owner Required',
    'BulkEditor.exclude_section_one': 'Exclude Applications with ',
    'BulkEditor.exclude_section_two': ' already filled out',
    'BulkEditor.exclude_unclassified_applications':
        'Exclude Unclassified Applications',
    'BulkEditor.includeRemovedApplications': 'Include Removed Applications',
    'Classify.appsManagedByPartner': 'Apps Managed By Partner',
    'Classify.businessOwnerSet':
        'This application’s default business owner has been updated.',
    'Classify.recovered': 'This application has been successfully recovered.',
    'Classify.recovered_error': 'There was an issue recovering the application',
    'Classify.removed': 'This application has been successfully removed.',
    'Classify.removed_error': 'There was an issue removing the application',
    'Classify.riskSet': 'This application’s risk has been updated.',
    'Classify.statusSet':
        'This application’s lifecycle stage has been updated.',
    'Classify.success': 'This application has been successfully classified.',
    'Classify.survey_workflow_notice':
        'This will send the user an email from the Auvik SaaS Management platform and redirect them into the software, where they will have to authenticate with their credentials. This will be branded with your logos, but may be confusing to users if you have not communicated to them what the Auvik SaaS Management software is first.',
    'ClassifyModal.application_users': 'Application Users',
    'ClassifyModal.email_personal': 'Personal Email',
    'ClassifyModal.purpose_workflow': 'Application Business Purpose Workflow',
    'ClassifyModal.request_purpose': 'Request Purpose',
    'ClassifyModal.request_purpose_description':
        'This workflow is designed to gather information from employees that use this application.',
    'ClassifyModal.requested_users': 'Requested Users',
    'ClassifyModal.send_workflow': 'Survey Workflow',
    'Clients.add_notice':
        'Using a partner deployment script through your RMM or MDM? If so, there is no need to manually create the client here, the client will automatically be created when the script is run. For more details check out our <a href="https://support.auvik.com/hc/en-us/sections/11423558673172" class="link--infoAlert underline" target="_blank" rel="noopener noreferrer nofollow"><span style="font-weight:600;">Deployment Guide</span></a>.',
    'Clients.addIntegration': 'Add integration',
    'Clients.addModal.formFields.domains.invalidDomainsError':
        'Domains must be comma separated and each domain must be valid.',
    'Clients.addModal.integrationType.googleAutomated': 'Google SSO Setup',
    'Clients.addModal.integrationType.microsoftEntraIDAutomated':
        'Microsoft Entra ID SSO Setup',
    'Clients.addModal.integrationType.microsoftEntraIDManual':
        'Manual Microsoft Entra ID Setup',
    'Clients.addModal.integrationType.none': 'Skip integration',
    'Clients.addModal.MicrosoftAuth.accessGrantedCheckbox':
        'Admin access granted for Microsoft Entra ID tenant <span style="font-weight:600;">{{tenantName}}</span>.',
    'Clients.addModal.MicrosoftAuth.appAuth': 'Access tenant information',
    'Clients.addModal.MicrosoftAuth.tenants': 'Sign in to view tenant list',
    'Clients.addModal.steps.1': 'Please choose the integration type.',
    'Clients.addModal.steps.1.microsoftEntraID':
        'Please choose the Microsoft Entra ID integration type.',
    'Clients.addModal.steps.1a':
        'Would you like to use an integration method to add a client?',
    'Clients.addModal.steps.2.googleAutomated':
        'Please log in using your GWS Admin Credentials below to set up a new or update an existing integration. (Note: You must have administrative privileges on the GWS account you are integrating with.)',
    'Clients.addModal.steps.2.manual':
        'Provide the client information in the fields below.',
    'Clients.addModal.steps.2.microsoftEntraIDAutomated':
        'In order for us to retrieve a list of tenants, please log in using your Microsoft Admin credentials below.',
    'Clients.addModal.steps.3.automated':
        'Confirm the selected Microsoft Entra ID Tenant or choose a different one.',
    'Clients.addModal.steps.4.automated':
        'Authenticate below using your Microsoft Admin account to grant us permission to collect information about the selected Microsoft Entra ID Tenant.',
    'Clients.addModal.steps.5':
        '<span style="font-weight:600;">We have successfully integrated into your identity management platform.</span> Choose to scan all groups and users for the most in-depth SaaS insights, or select a specific group of users from your identity manager to exclude from the scan.',
    'Clients.addToPanelDescription':
        'This will add the client to the visible panel.',
    'Clients.disableActivity': 'Disable activity collection',
    'Clients.disableActivityDescription':
        'Disable activity collection will stop all agents from sending security logs, user information, and application information installed under this environment.',
    'Clients.disconnectIntegration':
        '<integration>Are you sure you want to disconnect {{integration}}?</integration><br><br>Disconnecting will stop data syncing and could disrupt workflows or automations relying on this integration. You can reconnect anytime, but some settings may need reconfiguration.',
    'Clients.domain(s)': 'Client Domain(s)',
    'Clients.enableActivity': 'Enable activity collection',
    'Clients.enableActivityDescription':
        'Enabling activity collection will make all agents start sending security logs, user information, and application information installed under this environment.',
    'Clients.in_learning_mode': 'Clients in Learning Mode',
    'Clients.integration.billingDisclaimer':
        'Integrating with the Microsoft Entra ID or Google Workspace will add users with any recent login activity to your deployment, which will increase your active user count.',
    'Clients.integrations.pageLoadError':
        'Error loading tenant settings. Please try again.',
    'Clients.permanentlyDelete': 'Permanently delete client',
    'Clients.permanentlyDeleteWarning':
        'This action will permanently delete <ClientName>{{clientName}}</ClientName>, and it is irreversible. Are you sure you want to continue?',
    'Clients.removeFromPanelDescription':
        'This will remove the client from the visible panel. It will not stop data collection; it is recommended only to do this if an environment no longer needs management.',
    'Clients.save.error': 'Settings could not be saved.',
    'Clients.save.success': 'Settings successfully saved.',
    'Clients.setAsInternal': 'Set as internal deployment',
    'Clients.updateIntegration': 'Update Integration',
    'ClientSettings.blocked_enabled': 'Add Blocked Lifecycle Stage to Client',
    'ClientSettings.blocked_enabled_description':
        "Applications defined with the lifecycle stage 'Blocked' will block users from visiting their web applications.",
    'ClientSettings.cw_clientId': 'External Client ID',
    'ClientSettings.cw_clientId_description':
        'This is your client’s unique identifier to map to your internal RMM, MDM, or CRM.',
    'ClientSettings.hide_personal_details':
        'Disable personal account data collection',
    'ClientSettings.hide_personal_details_description':
        'Removes non-company domain data (such as personal gmail accounts) from reports and logs during the data collection process.',
    'ClientSettings.hidePersonalDetails.confirmation.descriptionBody':
        'This will obfuscate or remove any accounts, aliases, or security logs or other personally identifiable info that is not associated with your company domain. Personal apps will still be captured but will be filtered from reports by default.',
    'ClientSettings.hidePersonalDetails.confirmation.descriptionHeading':
        'Would you like to remove any previously captured personal data?',
    'ClientSettings.hidePersonalDetails.confirmation.title':
        'Remove Captured Personal Data',
    'ClientSettings.hidePersonalDetails.redactionError':
        'Error submitting redaction request.',
    'ClientSettings.hidePersonalDetails.redactionSubmitted':
        'Redaction request submitted.',
    'ClientSettings.identity_internalID':
        'Auvik SaaS Management Microsoft Entra ID/Workspace ID',
    'ClientSettings.identity_internalID_description':
        'This is for internal use only.',
    'ClientSettings.security_logging': 'Application Security Logging',
    'ClientSettings.security_logging_description':
        'If this is enabled, Auvik SaaS Management will automatically collect information around download/upload behavior, login form submissions, and other data points for the security logs.',
    'ClientSettings.tenantReferenceId': 'Auvik SaaS Management Tenant ID',
    'ClientSettings.title': 'Client Settings',
    'CloseOauth2.errorMsg.noAccessTokenProvided': 'No access token provided.',
    'CloseOauth2.errorMsg.notoken_noTenantId_provided':
        'No access token or tenant ID provided.',
    'CloseOauth2.errorMsg.useCorporateAccount':
        'You must use a corporate Google Account to access Auvik SaaS Management. Personal Accounts are not enabled.',
    'Colors.auvikBrown': 'Brown',
    'Colors.auvikCyan': 'Cyan',
    'Colors.auvikEggplant': 'Eggplant',
    'Colors.auvikGreen': 'Green',
    'Colors.auvikLavender': 'Lavender',
    'Colors.auvikLime': 'Lime',
    'Colors.auvikOrange': 'Orange',
    'Colors.auvikPink': 'Pink',
    'Colors.auvikPurple': 'Purple',
    'Colors.auvikRed': 'Red',
    'Colors.auvikSkyBlue': 'Blue',
    'Colors.auvikYellow': 'Yellow',
    'Configure.browser_agent':
        'If your deployment requires group policy to deploy the extensions, you can find the group policy installation instructions here.',
    'Configure.bulk_editor':
        'Here you can bulk edit applications and change things such as: Business Owners, Statuses, etc.',
    'Configure.classify':
        'Applications are considered unclassified if they have been used by a member of the organization. Classifying an application will move the application into the Unmanaged Application dashboard where they will need a Business Owner and a lifecycle stage other than “Discovered” assigned.',
    'Configure.client_settings':
        'Client Settings allow you determine the way this environment is configured and what functionality is accessible.',
    'Configure.devices':
        'Here you can view your devices, their access, SSO status, etc. You can also retrieve the deployment script here.',
    'Configure.domain_description':
        'Specify which domains belong to your organization in order to better identify work-related activities.',
    'Configure.identity_management_description':
        'Configure <b>Microsoft Entra ID</b>, <b>Google Workspace</b>, or <b>Okta</b> to unlock richer visibility into users, groups and application usage.',
    'Configure.new_user_experience':
        'Here you can set up what experience a new user gets when Auvik SaaS Management is loaded for the first time. Customize the experience to your business.',
    'Configure.permissions':
        'Here you can restrict access to different components in the Auvik SaaS Management system. Setup default permissions and permission groups here.',
    'Configure.tag_editor':
        'Here you can edit your tags. Tags give you the ability to set custom information for each application. These tags can be used for querying. (Example Tags: HIPAA, PCI, Billable, Internal, External, 2FA)',
    'Configure.title': 'Platform Utilities',
    'ConfigureSelfUser.error.email': 'Email is required.',
    'ConfigureSelfUser.error.email.invalid': 'Email must be valid.',
    'ConfigureSelfUser.error.first_name': 'First name is required.',
    'ConfigureSelfUser.error.last_name': 'Last name is required.',
    'ConfigureSelfUser.error_saving':
        'We had a problem saving your settings. Please refresh and try again.',
    'ConfigureSelfUser.success_saving': 'Your settings have been updated.',
    'ConfigureSelfUser.update_information': 'Update Information',
    'ConfigureSelfUser.view_my_applications': 'View My Applications',
    'ConfigureSelfUserPartnerSettings.request_email_subject':
        'Application Information Request Email Subject',
    'ConfigureSelfUserPartnerSettings.request_email_template':
        'Application Information Request Email Body',
    'ConfigureSelfUserPartnerSettings.title': 'Partner Settings',
    'ContractManagement.alertNotSet': 'Alert not set',
    'ContractManagement.alertSet': 'Alert set',
    'ContractManagement.calendar': 'Calendar View',
    'ContractManagement.contracts': 'Contract List',
    'ContractManagement.list': 'Contract List',
    'ContractManagement.monthlyOnTheDay': 'Monthly on the {{day}}',
    'ContractManagement.monthToMonth': 'Month to Month',
    'ContractManagement.monthToMonthContract': 'Month to Month Contract',
    'ContractManagement.renewalContract': 'Renewal Contract',
    'ContractManagement.title': 'Contracts',
    'ContractManagement.upcoming_renewals': 'Upcoming renewals',
    'CSV.admin_user_email': 'Admin User Email',
    'CSV.admin_user_first_name': 'Admin User First Name',
    'CSV.admin_user_last_name': 'Admin User Last Name',
    'DataApi.error.notification': 'Something went wrong.',
    'Datecreated.filter.last7day': 'Last 7 days',
    'Datecreated.filter.last30day': 'Last 30 days',
    'Datecreated.filter.last90day': 'Last 90 days',
    'Deployment.client_scripts_warning':
        'These deployment scripts are intended for the currently logged in client, partner-level deployment scripts can be found in your partner dashboard.',
    'Deployment.deployment_guide': 'Deployment Guide',
    'Deployment.instructions_section_two':
        'For more information, please read our ',
    'Deployment.integrations_guide': 'Integrations Guide Documentation',
    'Deployment.mac_manual': 'MacOS Terminal Manual Deployment Script',
    'Deployment.mac_mdm': 'MacOS Terminal MDM Configuration Script',
    'Deployment.powershell': 'Windows PowerShell Deployment Script',
    'Deployment.status.Discovery': 'Discovery',
    'Deployment.status.Management': 'Management',
    'Deployment.status.Optimization': 'Optimization',
    'Deployment.token': 'Client Token',
    'Deployment.windows_bash': 'Windows Command Prompt Deployment Script',
    'DeploymentScripts.tabcontent': 'Deploying the Windows Agent',
    'Devices.autoupdate': 'Data refreshes automatically every 30s',
    'Devices.confirm_delete': 'Are you sure you want to remove this device?',
    'Devices.delete_notice':
        'This will not remove the Auvik SaaS Management agent from the device. For more details on how to remove the Auvik SaaS Management agent please see the <a href="https://support.auvik.com/hc/en-us/sections/11423558673172" target="_blank" rel="noopener noreferrer nofollow" class="link underline"><span style="font-weight:600;">Deployment Guide</span></a>.',
    'Devices.deleteDevice': 'Delete device',
    'Devices.deletedSuccessfully': 'Device deleted successfully.',
    'Devices.deleteFail': 'Unable to delete device.',
    'Devices.operatingSystem': 'Operating system',
    'Devices.release': 'Release',
    'Devices.total': 'Total devices',
    'DevicesDashboard.title': 'Devices',
    'Discovery.descriptions.cloud_logins':
        'indicates the amount of users in the organization that have provided login credentials to this system.',
    'Discovery.descriptions.cloud_users':
        'indicates the amount of users in the organization that have accessed this software utilizing the browser.',
    'Discovery.descriptions.desktop_users':
        'indicates the amount of users in the organization that have accessed this software utilizing a desktop software.',
    'Discovery.descriptions.lifecycle':
        'indicates that a clear state for the application has been set, whether it is approved or disapproved.',
    'Discovery.descriptions.microsoftEntraID':
        'indicates the amount of users in the organization that have logged into this software using their Microsoft Entra ID Login.',
    'Discovery.descriptions.owner':
        'are individuals that have been assigned to an application to serve as the primary point of contact around the application.',
    'Discovery.descriptions.purpose':
        'indicates that there is a clearly defined business purpose for this application in the platform.',
    'Discovery.descriptions.sso':
        'indicates that a user in the organization has logged into this software using Google or Microsoft SSO.',
    'DiscoveryReport.LifecycleOverview.description':
        'This is a breakdown of all your applications and their current state. It is recommended that applications should not be in the Discovery state, as their role inside the organization is unknown.',
    'Domains.confirm_description':
        'Adding or removing domains will change the way Auvik SaaS Management determines which application data is work-related, and also how users are identified. If you are adding or removing a domain, please give up to 24 hrs for the change to be accurately reflected.',
    'Domains.confirm_title': 'Modify Domain Configuration?',
    'Domains.description':
        'Specify which domains belong to your organization. Domains listed below may be set by your directory integrations or may be entered manually. Auvik SaaS Management uses these domains to better determine a user’s identity and to identify work related software usage.',
    'Domains.save_fail':
        'Unable to save Company Domains, please reload and try again.',
    'Domains.save_success': 'Company domains saved successfully.',
    'Edit.user_details': 'Edit User Details',
    'Edit.user_details.error.first_name': 'First name is required.',
    'Edit.user_details.error.last_name': 'Last name is required.',
    'Edit.user_details.error.saving':
        'We had a problem saving your changes. Please refresh and try again.',
    'Edit.user_details.error.title': 'Title is required.',
    'Edit.user_details.success.saving': 'User has been updated.',
    'EditTagsModal.createTagLink.error': 'Error creating tag.',
    'EditTagsModal.createTagLink.success': 'Tag created successfully.',
    'EditTagsModal.createTagSettings.error': 'Error creating tag.',
    'EditTagsModal.createTagSettings.success': 'Tag created successfully.',
    'EditTagsModal.title': 'Edit Tags',
    'EditTagsModal.updateTagLink.error': 'Error updating tag.',
    'EditTagsModal.updateTagLink.failure':
        'Not all tags were updated successfully. Please try again.',
    'EditTagsModal.updateTagLink.success': 'Updated tags successfully.',
    'EditTagsModal.updateTagSettings.success': 'Updated tags successfully.',
    'Error.missingRequiredParameters': 'Missing required parameters',
    'ErrorPage.error.permissions':
        'You don’t have permission to view this page.',
    'ErrorPage.goHome': 'Go back to home',
    'ErrorPage.oops': 'Well, this is awkward...',
    'Errors.start_greater_than_end':
        'Start date can’t be greater than end date.',
    'Extension.Policies.deploying.chrome': 'Chrome',
    'Extension.Policies.deploying.chrome.value':
        'Chrome Force-Install Extension Value',
    'Extension.Policies.deploying.description':
        'Group Policy needs deployed per customer manually, and should be deployed to cover the full breadth of browsers they use to get the most information possible. Below are the three most common-browsers we see when deploying Auvik SaaS Management.',
    'Extension.Policies.deploying.edge': 'Edge Chromium',
    'Extension.Policies.deploying.edge.value':
        'Edge Force-Install Extension Value',
    'Extension.Policies.deploying.firefox': 'Firefox',
    'Extension.Policies.deploying.firefox.value':
        'Firefox Browser Force-Install Extension Value',
    'Extension.Policies.deploying.title': 'Deploying The Group Policy',
    'FileUpload.uploadAFile': 'Upload a File',
    'Flags.genericCred': 'Service Cred',
    'Flags.None': 'None',
    'Flags.personalCred': 'Personal Cred',
    'Flags.sharedCred': 'Shared Cred',
    'Form.fieldRequired': 'Field required',
    'Form.validEmail': 'Field must be a valid email',
    'Form.validUuid': 'Field must be a valid UUID',
    'FunnelLayer.managedApps': 'Managed apps',
    'FunnelLayer.unclassifiedApps': 'Unclassified apps',
    'FunnelLayer.unmanagedApps': 'Unmanaged apps',
    'Home.admin_dashboard': 'Admin Dashboard',
    'Home.application_insights': 'My Application Insights',
    'Home.application_library': 'My Application Library',
    'Home.description':
        'Auvik SaaS Management helps your business understand what software is effective. You are part of this journey.',
    'Home.personal_settings': 'Personal Settings',
    'Home.quick_start': 'Quick Start Guide',
    'Home.session_paused': 'Your session is paused. Click here to resume.',
    'Home.title': 'Help empower your businesses technology decisions.',
    'HubSettings.Branding.brandDetails': 'Brand Details',
    'HubSettings.Branding.contactDetails': 'Contact Details',
    'HubSettings.Branding.hex': 'Brand Hex',
    'HubSettings.Branding.saved': 'Branding saved.',
    'HubSettings.Branding.unableToSave': 'Unable to Save Branding.',
    'HubSettings.partnerTenantConfigurationSettings':
        'Hub Configuration Settings',
    'HubSettings.save_branding': 'Save Branding',
    'HubSettings.tenantConfigurationSettings': 'Tenant Configuration Settings',
    'HubSettings.tenantDetails': 'Tenant Details',
    'ImageUpload.imageSelected': 'Selected Image',
    'Insights.serviceCredsUsed': 'Service Credentials Used',
    'Insights.sharedCredsUsed': 'Shared Credentials Used',
    'Insights.total_apps_discovered': 'Total Apps Discovered',
    'Insights.vendor_incidents': 'Impacting Vendor Incidents',
    'LicenseData.card.seeAll': 'See All License Types',
    'LicenseData.refreshButton.disabled.tooltip':
        'Integration data refreshes nightly, or can be refreshed manually after five minutes. Please try again shortly.',
    'LicenseData.status.notConnected.message':
        'Enable the integration connection to access the data.',
    'LicenseData.status.sync.error':
        'An error has occurred, please try again later or contact your administrator.',
    'LicenseData.status.sync.message': 'Last sync date {{date}}',
    'LicenseData.status.sync.noNewData': 'No new data available at this time.',
    'LicenseData.status.sync.success': 'License data successfully refreshed.',
    'LicenseData.status.syncFailed':
        'License data sync failed. Please check your connection settings and try again.',
    'Logged.out': 'You have been logged out',
    'Login.check_out_website': 'Check out our website to learn more.',
    'Login.first_step': 'First step, login with your provider',
    'Login.message': 'Please login below to access your dashboard.',
    'Login.Okta.button': 'Sign in with Auvik',
    'Login.sso': 'SSO to access your dashboard.',
    'Login.sso_trial':
        'Log-in with your SSO provider of choice to get your trial started!',
    'Login.title': 'Hey There!',
    'Login.trial': 'Start Your 30-Day Auvik SaaS Management Trial!',
    'Login.trial_sub_message':
        ' Just choose which identity provider your organization uses, and let’s get you setup. ',
    'Logo.forANM': 'Logo for Auvik Network Management',
    'Logo.forASM': 'Logo for Auvik SaaS Management',
    'Logo.forCompany': 'Company Logo',
    'Logout.go_to_login': 'Go to Login',
    'Logout.message': 'See you soon!',
    'Logs.accountFilter': 'Filter Accounts',
    'Logs.activityMetadata': 'Activity Metadata',
    'Logs.application_filter': 'Filter Applications',
    'Logs.application_logs_disabled': 'Application Logs Disabled',
    'Logs.application_security_logs': 'Application Security Logs',
    'Logs.applicationRisk': 'Application Risk',
    'Logs.companyDomainLogins': 'Company Domain Logins',
    'Logs.downloadFileDanger': 'Download File Danger',
    'Logs.downloadFileMimeType': 'Download File Mime Type',
    'Logs.downloadTotals': 'Download Totals',
    'Logs.googleLogin': 'Google Login',
    'Logs.hasFlags': 'Has Flags',
    'Logs.iPEntryPoints': 'IP Entry Points',
    'Logs.loginsDetected': 'Logins Detected',
    'Logs.metadata_search': 'Metadata Search',
    'Logs.sharedCredentials': 'Shared Credentials',
    'Logs.tab1': 'Application Log Data',
    'Logs.tab2': 'Application Log Workflow',
    'Logs.totalEntries': 'Total Entries',
    'Logs.user_filter': 'Filter Users',
    'Logs.workCredentials': 'Work Credentials',
    'ManageApplication.add_to_library': 'Add Application to Library',
    'ManageApplication.are_you_sure': 'Are you sure?',
    'ManageApplication.areYouSureDeleteApp':
        'Are you sure you want to delete {{appName}}?',
    'ManageApplication.confirmToDeleteApp': 'Confirm to delete application',
    'ManageApplication.create_new_tag': '+ Create Application Tag',
    'ManageApplication.error_application_load':
        'There was a problem loading the application settings.',
    'ManageApplication.error_saving':
        'There was an issue updating your preferences, please refresh and try again.',
    'ManageApplication.management_setting':
        'My Application Management Settings',
    'ManageApplication.managing_application': 'Managing this application',
    'ManageApplication.my_expertise': 'My Expertise With This Application',
    'ManageApplication.prompt_are_you_sure':
        'This will remove all of the history with the application, cannot be undone, and is not reversible.',
    'ManageApplication.remove_from_library': 'Remove From Library',
    'ManageApplication.settings_saved': 'Your settings have been saved.',
    'ManageApplication.successful_add':
        'Successfully added this application to your library.',
    'ManageApplication.unable_to_load':
        'Tried to load application settings without link and failed.',
    'ManageApplication.unable_to_load_team': 'Unable to lead team',
    'ManageApplicationAdmin.add_application_admin': 'Enable Application Admin',
    'ManageApplicationAdmin.add_first_link': 'Add First Link',
    'ManageApplicationAdmin.add_to_dashboard': 'Add To Dashboard',
    'ManageApplicationAdmin.contract_management': 'Contract Management',
    'ManageApplicationAdmin.custom_links_error': 'Unable to save Custom Links',
    'ManageApplicationAdmin.custom_links_updated':
        'Custom links have been updated.',
    'ManageApplicationAdmin.custom_links_verbiage':
        'You can add up to 3 custom links that can be shared across the organization for users to view.',
    'ManageApplicationAdmin.default_settings_error':
        'Issue saving application settings.',
    'ManageApplicationAdmin.default_settings_saved':
        'Application settings have been updated.',
    'ManageApplicationAdmin.default_verbiage':
        'These settings will be used for reports, workflows & visualization of applications inside of the Auvik SaaS Management dashboards.',
    'ManageApplicationAdmin.deploy_to_all': 'Deploy to all user’s dashboards',
    'ManageApplicationAdmin.enable_prompt':
        'This application should request users to add to their dashboard.',
    'ManageApplicationAdmin.error_adding': 'Issue adding application to user.',
    'ManageApplicationAdmin.error_loading':
        'There was an issue loading the admin dashboard.',
    'ManageApplicationAdmin.error_revoking':
        'Issue revoking application from user.',
    'ManageApplicationAdmin.error_updating_admin':
        'We had an issue updating this users admin status.',
    'ManageApplicationAdmin.licensed': 'Licensed',
    'ManageApplicationAdmin.nav_custom_links': 'Custom Links',
    'ManageApplicationAdmin.no_category_selected': 'No Category Selected',
    'ManageApplicationAdmin.no_tenant_link':
        'There are no users using this application, so there is nothing to administer.',
    'ManageApplicationAdmin.no_user_selected': 'Not Assigned',
    'ManageApplicationAdmin.note': 'Note: ',
    'ManageApplicationAdmin.permission_and_access':
        'Here you can determine administrators in the Auvik SaaS Management platform for this application. These administrators can set up workflows, run reports & configure settings for this application. You may also define which users have an active license to the application as well below.',
    'ManageApplicationAdmin.removed_app_successfully':
        'This application has successfully been removed from all dashboards.',
    'ManageApplicationAdmin.save_nav_links_settings':
        'Save Custom Link Settings',
    'ManageApplicationAdmin.successful_deploy':
        'Successfully deployed this application to all users’ dashboards.',
    'ManageApplicationAdmin.tenant_settings': 'Tenant Settings',
    'ManageApplicationAdmin.user_management': 'User Management',
    'ManagedTable.clear_filters': 'Clear Filters',
    'ManagedTable.newData.available': 'This table has new data',
    'ManagedTable.newData.loading': 'Loading new data',
    'ManagedTable.noResults': 'No data available.',
    'ManagedTable.noSearchResults': 'No search results found.',
    'ManagedTable.search': 'Search',
    'ManageUsers.partner_users': 'Partner Hub Users',
    'MicrosoftAuthenticationHandler.c': 'Log in with Microsoft',
    'Mocking.click_here': 'Click here to resume your session',
    'Mocking.info':
        'You are currently logged into a client organization. If you reload your browser you will be automatically logged out.',
    'Navigation.admin_dashboard': 'Admin Dashboard',
    'Navigation.application_insights': 'Application Insights',
    'Navigation.application_library': 'Application Library',
    'Navigation.customized_report': 'Customized Report',
    'Navigation.dashboard': 'Dashboard',
    'Navigation.office_365_configuration': 'Microsoft Entra ID Configuration',
    'Navigation.organization': 'Organization',
    'Navigation.personal_settings': 'Personal Settings',
    'Navigation.print_report': 'Print Report',
    'Navigation.setup_new_report': 'Setup New Report',
    'Notes.actionItem': 'Action Item',
    'Notes.active/completed': 'Active / Completed',
    'Notes.add': 'Add Notes',
    'Notes.archive': 'Archive',
    'Notes.archive_error': 'Unable to archive note.',
    'Notes.archive_saved': 'Note has been archived.',
    'Notes.businessCase': 'Business Case',
    'Notes.community': 'Community Notes',
    'Notes.community_imported': 'Community Imported',
    'Notes.discussionPoint': 'Discussion Point',
    'Notes.exclude_archived': 'Exclude Archived Notes',
    'Notes.manage': 'Manage Notes',
    'Notes.mark_as_complete': 'Mark as Complete',
    'Notes.publish_notice':
        'Would you like to share your notes and recommendations with other MSPs that are supporting users with this application?',
    'Notes.question': 'Question',
    'Notes.recommendation': 'Recommendation',
    'Notes.security': 'Security',
    'Notes.showCompletedNotes': 'Show Completed Notes',
    'Notes.status': 'Status (Active / Completed)',
    'Notes.total_active': 'Total Active Notes',
    'Notes.type_breakdown': 'Type Breakdown',
    'Notes.unarchive': 'Unarchive',
    'Notes.unarchive_error': 'Unable to unarchive note.',
    'Notes.unarchive_saved': 'Note has been unarchived.',
    'Notice.Clients.no_internal':
        "You haven’t yet selected which deployment is your internal deployment. Click 'Actions' next to your internal instance of Auvik SaaS Management to set one.",
    'Notice.CustomScripts.select_client':
        'Select a client you’d like to deploy from the dropdown or create a new one.',
    'Notice.no_contracts.part1':
        'You have not uploaded any contract data. This section allows you to track user licenses and understand which users are accessing the business applications you pay for. To get started visit the ',
    'Notice.no_contracts.part2':
        ' menu, select an app, and add your contract data.',
    'Notice.SalesDocs.new_partner':
        'Sales documents, demo reports, social media posts, and more will be generated with your branding and placed here. This process can take up to 24 hrs to complete.',
    'OAuth.close': 'Click here to close this page',
    'OAuth.close_popup': 'Click here to close this window',
    'OAuth.error':
        'Sorry, we encountered an error while processing your login. It’s possible closing this window and refreshing your original window will resolve this issue.',
    'OAuth.logging_in': 'Logging in...',
    'OAuth.return_to_login': 'Click here to go to the Login Page',
    'OAuth.wait': 'Please wait...',
    'Offboard.apps_using_sso': 'Apps Using Single-Sign On',
    'Offboard.apps_using_sso.total': 'Total apps offboard by revoking SSO',
    'Offboard.apps_with_shared_accts': 'Apps with Shared Accts',
    'Offboard.classified_apps': 'Offboarding - Classified Apps',
    'Offboard.client_apps': 'Client-Managed Apps',
    'Offboard.client_apps_to_remove': 'Client Apps to Remove',
    'Offboard.desktop_apps_and_no_username':
        'Desktop Apps & Apps with No Username',
    'Offboard.other_partner_apps': 'Other Partner Managed Apps',
    'Offboard.partner_apps_to_remove': 'Partner Apps to Remove',
    'Offboard.personal_apps': 'Offboarding - Personal Apps',
    'Offboard.sso_apps_to_remove': 'SSO Apps to Remove',
    'Offboard.third_party': 'Third Party Apps',
    'Okta.modal.clientDomain': 'Okta Domain',
    'Okta.modal.clientDomainHelper':
        'Your Okta domain name as found in your Okta URL <bold>e.g. https://mycompany.okta.com, https://mytest.oktapreview.com</bold>.',
    'Okta.modal.clientDomainPlaceholder': 'Enter your Okta client domain',
    'Okta.modal.clientId': 'Client ID',
    'Okta.modal.clientIdHelper':
        'View the <OktaLink>step-by-step guide</OktaLink> to generating a Client ID and Private Key.',
    'Okta.modal.clientIdPlaceholder': 'Enter your Okta client ID',
    'Okta.modal.privateKey': 'Private Key',
    'Okta.modal.privateKeyHelper':
        'View the <OktaLink>step-by-step guide</OktaLink> to generating a Client ID and Private Key.',
    'Okta.modal.privateKeyPlaceholder':
        'Enter the private key of your Okta application. This is the private key that you want to use to authenticate with Okta.',
    'Okta.modal.title': 'Okta Configuration',
    'Pagination.fromToCount': '{{from}}–{{to}} of <Count />',
    'Partner.dashboard.actions.disableActivity':
        'Disabling activity collection will stop all agents from sending security logs, user information, and application information installed under this environment.',
    'Partner.dashboard.actions.modal_aria': 'Actions for Client Modal',
    'Partner.dashboard.actions.remove_from_panel':
        'This will remove the client from the visible panel. It will not stop data collection; it is recommended only to do this if an environment no longer needs management.',
    'Partner.dashboard.actions.set_as_internal':
        'If your organization is using multi-tenant functionality, this should be ticked for your internal company to ensure permissions work throughout the platform.',
    'Partner.dashboard.actions.title': 'Actions for {{tenant}} Client',
    'Partner.dashboard.activeUserCount': 'Active User Count',
    'Partner.dashboard.applicationsClassified': 'Applications Classified',
    'Partner.dashboard.applicationsUnclassified': 'Applications Unclassified',
    'Partner.dashboard.client_name_error': 'Unable to save client name.',
    'Partner.dashboard.client_name_saved': 'Client name saved.',
    'Partner.dashboard.clientDeleted.failed': 'Unable to delete client.',
    'Partner.dashboard.clientDeleted.success':
        'Deletion of this tenant has begun. Completion time may vary based on the amount of data collected. This process will continue in the background if you navigate away from this page.',
    'Partner.dashboard.devices': 'Devices',
    'Partner.dashboard.google.identityIntegrationStatus': 'Google Workspace',
    'Partner.dashboard.microsoft.identityintegrationStatus':
        'Microsoft Entra ID',
    'Partner.dashboard.number_classified': '{{classified}} Classified',
    'Partner.dashboard.number_total': '{{totalApps}} Total',
    'Partner.dashboard.number_unclassified': '{{unclassified}} Unclassified',
    'Partner.dashboard.okta.identityIntegrationStatus': 'Okta',
    'Partner.dashboard.tenant.id': 'Tenant Id',
    'Partner.dashboard.tenant.name': 'Tenant Name',
    'Partner.dashboard.totalActiveUsers': 'Total Active Users (30 days)',
    'Partner.dashboard.totalApplications': 'Total Applications',
    'Partner.dashboard.totalClients': 'Total Clients',
    'Partner.dashboard.workspaceConfigured': 'Workspace Configured',
    'PartnerApplicationSettings.alert_text':
        'You can configure client applications defaults once you have deployed a client.',
    'PartnerApplicationSettings.alert_title':
        'No Client Applications To Manage',
    'PartnerApplicationSettings.description':
        'Applications stack is where partners can define default settings for the end client. On an update of any setting, the client’s applications will be automatically updated. Any new application entries under the client will inherit these values.',
    'PartnerDeployment.browser_agent': 'Browser Extension Deployment',
    'PartnerDeployment.desktop_agent': 'Agent Deployment',
    'PartnerInformation.billContactEmail': 'Billing Contact Email',
    'PartnerInformation.billContactName': 'Billing Contact Name',
    'PartnerInformation.billContactTitle': 'Billing Contact Title',
    'PartnerInformation.city': 'City',
    'PartnerInformation.name': 'Organization Name',
    'PartnerInformation.phone': 'Phone Number',
    'PartnerInformation.state': 'State',
    'PartnerInformation.streetAddress': 'Street Address',
    'PartnerInformation.title': 'Partner Information',
    'PartnerInformation.zip': 'Zip Code',
    'PartnerIntegration.save_successful': 'Integration saved successfully.',
    'PartnerIntegrations.title': 'Partner Integrations',
    'PartnerOrganization.add_client': 'Add Client',
    'PartnerOrganization.client_organizations': 'Clients',
    'PartnerOrganization.editClient': 'Edit Client',
    'PartnerOrganization.integrationStatus.connected': 'Authenticated',
    'PartnerOrganization.integrationStatus.disconnected': 'Disconnected',
    'PartnerOrganization.integrationStatus.noIntegration': 'Not Integrated',
    'PartnerOrganization.integrationStatus.updateRequired': 'Connection Failed',
    'PartnerOrganization.success_create':
        'This tenant has been successfully linked to your partner dashboard.',
    'PartnerOrganizations.login_to_organization': 'Login',
    'Permissions.default_new_user': 'Default Permission for New Users',
    'Permissions.default_permissions':
        'This is a default Permission and some settings cannot be changed.',
    'Picker.lifecycle.approved': 'Approved',
    'Picker.lifecycle.decommissioned': 'Decommissioned',
    'Picker.lifecycle.decommissioning': 'Decommissioning',
    'Picker.lifecycle.evaluating': 'Evaluating',
    'Picker.lifecycle.implementing': 'Implementing',
    'Picker.lifecycle.not_configured': 'Not configured',
    'Picker.lifecycle.unapproved': 'Unapproved',
    'Picker.managementState.managedApplication': 'Managed',
    'Picker.managementState.unclassifiedApplication': 'Unclassified',
    'Picker.managementState.unmanagedApplication': 'Unmanaged',
    'Picker.publisher.addNew': '--- Add New Publisher ---',
    'Pictograph.fullSmileLineEyesCyanDark':
        'Dark Cyan full smile line eyes pictograph',
    'Pictograph.primaryLightPurple': 'Light purple primary pictograph',
    'Profile.avatar': 'Avatar',
    'Profile.details': 'User details',
    'Profile.theme': '$t(Common.theme)',
    'Provider.Google.groupsSideBarTitle': 'GWS Groups',
    'Provider.Google.usersSideBarTitle': 'GWS Users',
    'Provider.GoogleConfiguration.disclaimer':
        "Google API Services requires the following disclosure to use Google Workspace: Auvik SaaS Management's use and transfer to any other app of information received from Google APIs adheres to <a href='https://developers.google.com/terms/api-services-user-data-policy' class='link underline'>Google API Services User Data Policy</a>, including the Limited Use requirements. ",
    'Provider.GoogleConfiguration.enabled_and_saved':
        'Google Workspace integration setup is successful! If you’ve already added users to Auvik SaaS Management, it may take up to 24 hours for these users to be synced with their Google account.',
    'Provider.GoogleConfiguration.Groups.sync_page':
        'Click on the import button below to force a synchronization of a Google Workspace Group. This will create the group in the reporting and workflow dashboards. These groups are automatically refreshed every hour.',
    'Provider.GoogleConfiguration.groups_title': 'Google Groups',
    'Provider.GoogleConfiguration.groups_title_tooltip':
        'These are groups synced from Google Workspace.',
    'Provider.GoogleConfiguration.is_configured':
        'The Google Workspace Integration has been configured.',
    'Provider.GoogleConfiguration.permission_error':
        'This account does not have access to user data on Google Workspace. Please select a different account and log in again.',
    'Provider.GoogleConfiguration.prompt_save':
        'Google Workspace login successful!  Click <span style="font-weight:600;">Save Settings</span> to begin importing Google Workspace users.',
    'Provider.GoogleConfiguration.scope_error':
        'Scope not configured correctly. Please re-login and ensure all scopes are selected.',
    'Provider.GoogleConfiguration.Users.sync_page':
        'View all user accounts from your organization’s Google Workspace. Use this page to identify and import users not yet in the system, enabling data collection and tracking for those individuals once usage is detected. Note if a user is part of an excluded group, their activity will not be collected—even if the user has been imported.',
    'Provider.GoogleConfiguration.users_title': 'Google Users',
    'Provider.Groups.error.message': 'Unable to get groups.',
    'Provider.Groups.notFound.message': 'Unable to get groups. No data.',
    'Provider.Groups.usersNotFound.message':
        'Unable to get provider group users.',
    'Provider.identityMgrID': 'Identity Mgr ID',
    'Provider.is_configured': 'The integration has been configured.',
    'Provider.Microsoft.groupsSideBarTitle': 'Microsoft Entra ID Groups',
    'Provider.Microsoft.usersSideBarTitle': 'Microsoft Entra ID Users',
    'Provider.MicrosoftConfiguration.application_id':
        'Microsoft Entra ID Application ID',
    'Provider.MicrosoftConfiguration.application_secret':
        // amazonq-ignore-next-line It is not an actual secret
        'Microsoft Entra ID Application Secret',
    'Provider.MicrosoftConfiguration.changing_tenant_id':
        'Updating Company Tenant ID',
    'Provider.MicrosoftConfiguration.changing_tenant_id_description':
        'This ID is your Tenant ID that can be found in the Microsoft Entra ID / Google Workspace portals, per our deployment documentation. However, it is common to update this if you are changing it after using a partner-level deployment script.',
    'Provider.MicrosoftConfiguration.configuration_title':
        'Microsoft 365 Active Directory - Configuration',
    'Provider.MicrosoftConfiguration.deployment':
        'Auvik SaaS Management Deployment',
    'Provider.MicrosoftConfiguration.enabled_and_saved':
        'Microsoft Entra ID integration setup is successful! If you’ve already added users to Auvik SaaS Management, it may take up to 24 hours for these users to be synced with their Microsoft Entra ID account.',
    'Provider.MicrosoftConfiguration.error_disable_group':
        'Encountered an issue: Unable to disable this group.',
    'Provider.MicrosoftConfiguration.error_excluding_group':
        'Encountered an issue: Unable to exclude group',
    'Provider.MicrosoftConfiguration.error_load_group':
        'Encountered an issue: Unable to load this group.',
    'Provider.MicrosoftConfiguration.error_loading_settings':
        'Unable to load settings.',
    'Provider.MicrosoftConfiguration.error_loading_users':
        'Error or insufficient privileges with app to load users.',
    'Provider.MicrosoftConfiguration.error_saving_group':
        'Encountered an issue: Unable to save group.',
    'Provider.MicrosoftConfiguration.error_user_delete':
        'There was an issue deleting this user.',
    'Provider.MicrosoftConfiguration.google_identity_provider_unique_id':
        'Google Workspace ID',
    'Provider.MicrosoftConfiguration.Groups.sync_page':
        'Click on the import button below to force a synchronization of an Microsoft Entra ID Group. This will create the group in the reporting and workflow dashboards. These groups are automatically refreshed every hour.',
    'Provider.MicrosoftConfiguration.groups_title': 'Microsoft Entra ID Groups',
    'Provider.MicrosoftConfiguration.groups_title_tooltip':
        'These are groups synced from Microsoft Entra ID.',
    'Provider.MicrosoftConfiguration.identity_id_change_alert_content':
        'You already have an enabled integration. It is very uncommon to change the Identity ID after this is configured. Your Application ID and Secret will be removed upon updating this ID.',
    'Provider.MicrosoftConfiguration.identity_id_change_alert_title':
        'Warning!',
    'Provider.MicrosoftConfiguration.identity_provider': 'Identity Provider',
    'Provider.MicrosoftConfiguration.identity_provider_sync_enabled':
        'Sync Enabled',
    'Provider.MicrosoftConfiguration.identity_provider_unique_id':
        'Identity Provider Unique ID',
    'Provider.MicrosoftConfiguration.integration_message':
        'After completing the integration process, we’ll retrieve SaaS and User data from Microsoft Entra ID for the past 30 days. Within a few minutes, you will be able to view new activities under the "Applications" menu.',
    'Provider.MicrosoftConfiguration.is_configured':
        'The Microsoft Entra ID Integration has been configured.',
    'Provider.MicrosoftConfiguration.microsoft_identity_provider_unique_id':
        'Tenant ID',
    'Provider.MicrosoftConfiguration.no_save':
        'Unable to save settings because credentials did not validate.',
    'Provider.MicrosoftConfiguration.no_users': 'No users found in this group.',
    'Provider.MicrosoftConfiguration.on_premises_user_principal_name':
        'On-premises User Principal Name',
    'Provider.MicrosoftConfiguration.re_enter_secret':
        'Secret is not viewable after saving.',
    'Provider.MicrosoftConfiguration.success_group_enabled_added':
        'This group has been created and is enabled in your reports.',
    'Provider.MicrosoftConfiguration.success_group_excluded':
        'Group excluded successfully. Users in this group will not be imported or scanned for activity.',
    'Provider.MicrosoftConfiguration.success_group_excluded_added':
        'This group has been created and is excluded in your reports.',
    'Provider.MicrosoftConfiguration.success_group_included':
        'Group included successfully. Users in this group will be imported or scanned for activity.',
    'Provider.MicrosoftConfiguration.success_group_updated':
        'This group has been updated.',
    'Provider.MicrosoftConfiguration.success_new_tenant_details':
        'Successfully updated tenant settings.',
    'Provider.MicrosoftConfiguration.success_user_deleted':
        'This user was deleted.',
    'Provider.MicrosoftConfiguration.sync': 'Sync',
    'Provider.MicrosoftConfiguration.sync_disabled':
        'Microsoft Entra ID Sync is disabled.',
    'Provider.MicrosoftConfiguration.sync_enabled':
        'Microsoft Entra ID Sync is enabled.',
    'Provider.MicrosoftConfiguration.tenant': 'Microsoft Entra ID Tenant',
    'Provider.MicrosoftConfiguration.tenant_id': 'Microsoft Entra ID Tenant ID',
    'Provider.MicrosoftConfiguration.tenantSelector.noTenantsFound':
        'No Tenants Found',
    'Provider.MicrosoftConfiguration.tenantSelector.tooltip':
        'Microsoft Entra ID Tenant is the unique ID of the Microsoft Entra ID tenant that you want to integrate with. If you have integrated with all tenants in your Microsoft Entra ID environment, no tenants will be displayed in the list.',
    'Provider.MicrosoftConfiguration.user_type': 'User Type',
    'Provider.MicrosoftConfiguration.Users.sync_page':
        'View all user accounts from your organization’s Microsoft Entra ID. Use this page to identify and import users not yet in the system, enabling data collection and tracking for those individuals once usage is detected. Note if a user is part of an excluded group, their activity will not be collected—even if the user has been imported.',
    'Provider.MicrosoftConfiguration.users_title': 'Microsoft Entra ID Users',
    'Provider.OktaConfiguration.enabled_and_saved':
        'Okta integration successful! We’ve started ingesting your application usage data, and full insights should be available within 24 hours.',
    'Provider.Shared.configure_integration': 'Configure your integration',
    'Provider.Shared.created_client': 'Client created successfully.',
    'Provider.Shared.error_saving_settings':
        'Encountered an issue: Unable to save settings.',
    'Provider.Shared.error_saving_user':
        'Unable to save user, please refresh and try again.',
    'Provider.Shared.import': 'Import',
    'Provider.Shared.saved': 'Identity sync settings successfully updated.',
    'Provider.Shared.success_user_added': 'User successfully added.',
    'Provider.Shared.unable_create_client': 'Unable to create Client.',
    'ProviderGroups.searchByUserName': 'Search by user name',
    'QBR.AppClassificationScore': 'App Mgmt Score',
    'QBR.applicationApprovalStatus': 'Application Approval Status',
    'QBR.applicationClassificationStatus': 'Application Classification Status',
    'QBR.applicationManagementStatus': 'Application Management Status',
    'QBR.AppOverlapScore': 'Overlap Score',
    'QBR.betweenFirstAndLastDays': 'Between {{firstDay}} and {{lastDay}}',
    'QBR.changeOvertheLastNDaysPercent':
        'Change over the last {{dayDifference}} days is <span style="color:{{percentChangeColor}};font-weight:600;">{{pointDirection}}{{percent}}%</span>.',
    'QBR.definitions.insights':
        'Insights provides an overview of key data including the number of applications discovered during the selected time frame, as well as the number of detected security incidents.',
    'QBR.definitions.notes':
        'Notes & Recommendations provides an overview of all active notes & recommendations as well as completed notes.',
    'QBR.emptyHealthScoreCard':
        'No device is currently available to show the SaaS health score chart.',
    'QBR.ManagedAppScore': 'Managed App Score',
    'QBR.SaaSSophisticationScore': 'SaaS Health Score',
    'QBR.scoreHistoryNDays': 'Score History (Over {{dayDifference}} Days)',
    'QBR.scoreInsightsNDays': 'Score Insights (Over {{dayDifference}} Days)',
    'QBR.ShadowITScore': 'Unclassified App Score',
    'QBR.top10ManagedApplicationsByUsage':
        'Top 10 Managed Applications By Usage',
    'QBR.top10UnApprovedApplicationsByUsage':
        'Top 10 Unapproved Applications By Usage',
    'QBR.top10UnClassifiedApplicationsByUsage':
        'Top 10 Un-Classified Applications By Usage',
    'QBR.top10UnManagedApplicationsByUsage':
        'Top 10 Un-Managed Applications By Usage',
    'QBR.UnapprovedAppScore': 'Unapproved Score',
    'QBR.yourAchievedYourHighestScoreOn':
        'You achieved your highest score <ScoreChip/> on {{day}}.',
    'QBR.yourCurrentScore.whichIsConsidered':
        'Your current score is <ScoreChip/> which is considered <MakeItBold />.',
    'QBR.yourScorehasDecreased_one':
        'Your score has decreased by {{pointChange}} point.',
    'QBR.yourScorehasDecreased_other':
        'Your score has decreased by {{pointChange}} points.',
    'QBR.yourScorehasIncreased_one':
        'Your score has increased by {{pointChange}} point.',
    'QBR.yourScorehasIncreased_other':
        'Your score has increased by {{pointChange}} points.',
    'QBR.yourScorehasStayedTheSame': 'Your score has stayed the same.',
    'QBRFirst.definitions.AppClassificationScore':
        'These results highlight the number of applications within your environment that are either Managed, Unmanaged, or Unclassified. The score is calculated based on the weight of usage based on each application.',
    'QBRFirst.definitions.AppOverlapScore':
        "This is a breakdown of all the category / subcategories that have more than one application in them within your environment. For example, if more than one application is being used for 'File Sharing', those applications will show here.",
    'QBRFirst.definitions.ManagedAppScore':
        'These results compare the number of Managed applications versus the number of Unmanaged applications. Striving to keep the number of Managed Applications greater than Unmanaged applications means your organizations knows who is responsible for applications, their purpose, and their lifecycle stage.',
    'QBRFirst.definitions.SaaSSophisticationScore':
        'This is a quarterly assessment of your SaaS landscape. Each score is weighted to determine an overall SaaS Health score.',
    'QBRFirst.definitions.ShadowITScore':
        'These results represent the application usage found within your environment that is considered Unclassified. These applications, especially those with a large amount of usage should be evaluated. The breakdown table below shows the Top 10 Unclassified applications based on usage from the quarter.',
    'QBRFirst.definitions.UnapprovedAppScore':
        'This is both a visual representation and breakdown of the Unapproved applications and their usage within your environment. The breakdown table shows the Top 10 Unapproved applications based on usage from the quarter.',
    'Risk.Alert': 'Alert',
    'Risk.Critical': 'Critical',
    'Risk.High': 'High',
    'Risk.Low': 'Low',
    'Risk.Medium': 'Medium',
    'Risk.numberAppsAtRiskLevel': '{{value}} {{text}} risk applications',
    'Risk.Safe': 'Safe',
    'Risks.critical':
        'Critical risk applications indicate a high level of potential vulnerability or risk to your business, each of these applications should be evaluated. These often include data, networking, infrastructure, or security systems.',
    'Risks.high':
        'High risk applications indicate an application that may have sensitive data, introduce internal business process risk, or house pertinent information. These often include engineering and IT tools, data tools, or communications tools.',
    'Risks.low':
        'Low risk applications are often safe for a business when used properly. These often include productivity tools.',
    'Risks.medium':
        'Medium risk applications are applications that need to be evaluated but when used properly don’t impose risk to the business. These often include sales and marketing tools.',
    'Risks.safe':
        'Safe applications are applications that do not typically prove risk to an organization.',
    'SalesDocs.download_all': 'Download All Files',
    'SalesHub.title': 'Sales Docs',
    'Search.client_or_user': 'Enter a Client Name or User',
    'SearchingAppsStep.progressBar.searchApps': 'Searching applications',
    'SearchingAppsStep.progressBar.setupIntegration':
        'Setting up the integration',
    'SearchingAppsStep.step1': 'Analyzing SSO Logs',
    'SearchingAppsStep.step2': 'Discovering Shadow IT',
    'SearchingAppsStep.step3': 'Finding Shared Accounts',
    'SendEmail.header':
        "The following email content will be automatically sent to the client upon hitting 'Send'.",
    'Session.doesNotHavePermission':
        'You do not have permission to access the Auvik SaaS Management Hub, please contact your system administrator or contact customer care at support@auvik.com',
    'SetupUser.accept_tos':
        'I have read and agree to the <a href="https://www.auvik.com/terms/" class="link underline" target="_blank" rel="noopener noreferrer nofollow" data-trackid="termsAndConditions"><span style="font-weight:600;">Terms and Conditions</span></a> and understand the <a href="https://www.auvik.com/privacy-policy/" class="link underline" target="_blank" rel="noopener noreferrer nofollow" data-trackid="dataPrivacyPolicy"><span style="font-weight:600;">Data Privacy Notice</span></a>.',
    'SetupUser.error_accept_tos': 'You must accept the Terms of Service.',
    'SetupUser.error_all_fields': 'You must fill out all required fields.',
    'SetupUser.error_saving_settings': 'Error Saving Settings',
    'SetupUser.get_started': 'Get Started',
    'SetupUser.prompt_photo':
        'You sure are looking good, prefer a different shot?',
    'SetupUser.save_and_continue': 'Save & Continue',
    'SetupUser.title_prompt':
        'Welcome to Auvik SaaS Management! Just provide us some information and we’re ready to go. Check out our <a href="https://www.auvik.com/saas-management/" class="link underline" target="_blank" rel="noopener noreferrer nofollow" data-trackid="visitOutWebsiteInitialSetup"><span style="font-weight:600;">website</span></a> to understand how Auvik SaaS Management works!',
    'SetupUser.tos': 'Terms of Service',
    'Sidebar.bulk_editor': 'Application Bulk Editor',
    'Sidebar.chip_new': 'New',
    'Sidebar.classify': 'Application Classification',
    'Sidebar.client_settings': 'Client Settings',
    'Sidebar.demo_environment': 'Demo Instance',
    'Sidebar.deployment': 'Deployment',
    'Sidebar.devices': 'Devices',
    'Sidebar.domains': 'Domains',
    'Sidebar.extension': 'Browser Extension Deployment',
    'Sidebar.id_management_integration': 'Identity Management Integration',
    'Sidebar.manage_users': 'Manage Users',
    'Sidebar.new_user_experience': 'New User Experience',
    'Sidebar.permissions': 'Permissions',
    'Sidebar.return_to_auvik': 'Network Management',
    'Sidebar.tag_editor': 'Tag Editor',
    'Sidebar.webhooks': 'Webhooks',
    'Sources.filter.applicationCategories': 'Application Categories',
    'Sources.filter.applicationCategories.cloud': 'Cloud',
    'Sources.filter.applicationCategories.hybrid': 'Hybrid',
    'Sources.filter.browser': 'Browser',
    'Sources.filter.desktop': 'Desktop Activity',
    'Sources.filter.download': 'Download Activity',
    'Sources.filter.google': 'GWS Login',
    'Sources.filter.googleSSO': 'Google SSO',
    'Sources.filter.microsoftEntraID': 'Microsoft Entra ID Login',
    'Sources.filter.microsoftSSO': 'Microsoft SSO',
    'Sources.filter.okta': 'Okta Login',
    'Sources.filter.quickScan': 'Browser History',
    'Sources.filter.sso': 'SSO',
    'Sources.filter.webActivity': 'Web Activity',
    'Sources.filter.webLogin': 'Form Login',
    'SSOSupport.filter.at_least_one_detected': 'At least one SSO detected',
    'SSOSupport.filter.available_not_in_use': 'Available - Not in use',
    'SSOSupport.filter.available_not_in_use.tooltip':
        'Apps that match this filter provide an opportunity to improve your security posture by adding them to your SSO Provider.',
    'SSOSupport.filter.unavailable': 'Unavailable',
    'SSOSupportIcons.sso_providers.google_sso': 'Google SSO',
    'SSOSupportIcons.sso_providers.microsoft_sso': 'Microsoft SSO',
    'SSOSupportIcons.tooltip.discovered_by': 'Discovered by: {{values, list}}',
    'SSOSupportIcons.tooltip.discovered_by.browser_extension':
        'Browser Extension',
    'SSOSupportIcons.tooltip.discovered_by.google_workspace':
        'Google Workspace',
    'SSOSupportIcons.tooltip.discovered_by.microsoftEntraID':
        'Microsoft Entra ID Login',
    'SSOSupportIcons.tooltip.header': 'Available SSO Methods',
    'SSOSupportIcons.tooltip.in_use': 'In use',
    'SSOSupportIcons.tooltip.not_in_use': 'Not in use',
    'SSOTypes.discoveredSSOClientsCount_one':
        'Discovered {{count}} client with {{ssoType}} coverage',
    'SSOTypes.discoveredSSOClientsCount_other':
        'Discovered {{count}} clients with {{ssoType}} coverage',
    'SSOTypes.filter.google': 'Google',
    'SSOTypes.filter.microsoft': 'Microsoft',
    'SSOTypes.filter.notAvailable': 'Not available',
    'SSOTypes.filter.ssoCoverage': 'SSO Coverage',
    'SuccessfulIntegrationSetup.button': 'Start Exploring',
    'SuccessfulIntegrationSetup.oktaBanner.button': 'Configure Now',
    'SuccessfulIntegrationSetup.oktaBanner.text':
        'Supercharge your application insights by configuring Okta alongside your {{integrationType}} integration.',
    'SuccessfulIntegrationSetup.text':
        "Your client has been successfully added and the integration is now set up. We've begun collecting application and user data. It may take a few hours for the data to appear, so check back soon to start exploring insights.",
    'Table.customizeColumns': 'Customize Columns',
    'Table.rowsPerPage': 'Rows per page',
    'TenantConfiguration.error_saving_settings':
        'Encountered an issue: Unable to save settings.',
    'TenantIdentifier.subscriber.linkFailure':
        'Subscriber was not linked to client.',
    'TenantIdentifier.subscriber.linkSuccess':
        'Subscriber successfully linked to client.',
    'TenantJob.status.completed': 'Completed',
    'TenantJob.status.failed': 'Failed',
    'TenantJob.status.inProgress': 'In Progress',
    'TenantJob.status.pending': 'Pending',
    'TenantSettings.enableAuvikSupportAccess': 'Allow Auvik Support Access',
    'TenantSettings.qbrToCBR': 'Change QBR to CBR (Customer Business Review)',
    'TenantSettings.saved': 'Settings saved.',
    'TenantSettings.unableToSave': 'Unable to Save Settings.',
    'TenantSettings.user_tracking':
        'Permit administrative activity tracking within Auvik SaaS Management for website analysis and improvement. Deselect to opt-out.',
    'Theme.dark': 'Dark',
    'Theme.darkMode': 'Dark Mode',
    'Theme.light': 'Light',
    'Theme.system': 'System settings',
    'Toggle.excludeDefaultSet': 'Exclude Apps with Existing Rules Set',
    'Trial.daysRemaining':
        'There are <span style="font-weight:600;">{{daysLeft}}</style> days remaining in your free trial.',
    'Trial.daysRemainingContactForPricing_one':
        'There are <Date /> day remaining in your Auvik SaaS Management Trial. For assistance or pricing contact <EmailAddress />.',
    'Trial.daysRemainingContactForPricing_other':
        'There are <Date /> days remaining in your Auvik SaaS Management Trial. For assistance or pricing contact <EmailAddress />.',
    'Trial.viewPricing': 'View Pricing',
    'Trial.viewPricing.chooseYourPlan': 'Choose Your Plan',
    'Trial.viewPricing.contactTeam': 'Contact Our Team',
    'Trial.viewPricing.exclusive': 'Exclusive',
    'Trial.viewPricing.exclusivePlan.email.body':
        'Tell me more about Exclusive MSP and Partner Pricing for Auvik SaaS Management.',
    'Trial.viewPricing.exclusivePlan.email.subject':
        'Tell me more about Exclusive MSP & Partner Pricing for Auvik SaaS Management',
    'Trial.viewPricing.features.appsMonitored':
        '60,000 Cloud, SaaS, Desktop, and Business Apps Monitored & Protected',
    'Trial.viewPricing.features.automated':
        'Automated App, Discovery across the Endpoint, Cloud, and Browser Collectors',
    'Trial.viewPricing.features.detailedReports':
        'Detailed Reports for Security, Onboard/Offboard, and Shadow IT',
    'Trial.viewPricing.features.healthScore': 'SaaS Health Score',
    'Trial.viewPricing.features.logs':
        '365 Days Security Log Filtering & Storage',
    'Trial.viewPricing.features.sharedMonitoring':
        'Shared Account/Service Account Monitoring',
    'Trial.viewPricing.features.unlimitedDevices':
        'Unlimited Number of Devices, Sites & Applications',
    'Trial.viewPricing.features.unlimitedReports':
        'Unlimited Number of Reports & Alerts',
    'Trial.viewPricing.mspPartnerPricing': 'MSP & Partner Pricing',
    'Trial.viewPricing.planPrice.1': '$3',
    'Trial.viewPricing.planPrice.2': 'USD',
    'Trial.viewPricing.planPrice.3': 'per end user*',
    'Trial.viewPricing.planPrice.email.body':
        'Tell me more about exclusive End-user Pricing for Auvik SaaS Management.',
    'Trial.viewPricing.planPrice.email.subject':
        'Tell me more about exclusive End-user Pricing for Auvik SaaS Management',
    'Trial.viewPricing.planPrice.featuresIncluded':
        'What features are included in Auvik’s SaaS management',
    'Trial.viewPricing.title.subscribe':
        'Subscribe to Auvik SaaS Management in 1 simple step.',
    'TrialExpiryJailPage.contactSales': 'Contact our sales team',
    'TrialExpiryJailPage.main.phone': '+1-519-804-4700 x110',
    'TrialExpiryJailPage.or': 'Or',
    'TrialExpiryJailPage.phone.north.america':
        '+1-866-592-8845 (North America)',
    'TrialExpiryJailPage.phone.uk': '+44 (0) 203 884 1655 (UK)',
    'TrialExpiryJailPage.purchaseSubscription': 'Purchase a Subscription',
    'TrialExpiryJailPage.sales.email': 'sales@auvik.com',
    'TrialExpiryJailPage.title': 'Your SaaS Management trial has expired',
    'TrialExpiryJailPage.viewPricing': 'View Pricing',
    'TrialInfo.auvikSupport.info':
        'Have questions or need assistance? Contact our Auvik Customer Success team for help!',
    'TrialInfo.auvikSupport.send_email': 'Send Email',
    'TrialInfo.daysLeft_one':
        'Your trial expires in <span style="font-weight:600;">1 day</span>.',
    'TrialInfo.daysLeft_other':
        'Your trial expires in <span style="font-weight:600;">{{count}} days</span>.',
    'TrialInfo.daysLeft_zero': 'Your trial has expired.',
    'UnclassifiedAppsPage.applicationRisk': 'Application Risk',
    'UnclassifiedAppsPage.categoryBreakdown': 'Category Breakdown',
    'UnclassifiedAppsPage.unclassifiedTotalUsage': 'Unclassified Total Usage',
    'User.admin': 'User Admin',
    'User.disabled': 'Disabled user',
    'User.expired': 'Expired user',
    'User.offboarding': 'User Offboarding',
    'User.overview': 'Overview',
    'User.permission.saved': 'User permission saved.',
    'UserAdminAplications.description':
        'As an administrator, you can set whether or not a user has an application added to their dashboard. You may also enable them to be an administrator in the platform.',
    'UserAdminSettings.description':
        'As an administrator, you can disable users so they do not count against your license limit, as well as set other tenant administrators.',
    'UserAdminSettings.user_admin': 'Tenant Administrator',
    'UserAdminSettings.user_disabled': 'Disable User. ',
    'UserAdminSettings.user_disabled_subtext':
        '(This will remove them from all reports, not allow them to log in, and will block user activity management.)',
    'UserAdminSettings.user_management': 'User Management',
    'UserAdminSettings.user_permissions': 'Permissions',
    'UserAdminSettings.user_settings_saved':
        'User settings successfully saved.',
    'UserAdminSettings.view_permissions': 'View Permissions',
    'UserBar.internal_switch':
        'Currently viewing Internal Deployment, Return to Partner Hub',
    'UserBar.mocking_org_tooltip':
        'To View or Modify Personal Settings, Please log out of your client’s organization.',
    'UserDashboard.last_app_added': 'Last Application Added <Date/>',
    'UserDashboard.last_calculated': 'Last Calculated <Date/>',
    'UserDashboard.last_week_active_applications':
        'Last Week’s Active Applications',
    'UserDashboard.last_week_active_users': 'Last Week’s Active Users',
    'UserDashboard.lastAccountAdded': 'Last Account Added <Date/>',
    'UserDashboard.recently_added_applications': 'Recently Added Applications',
    'UserDashboard.run_reports': 'Run Reports',
    'UserDashboard.title': 'User Application Dashboard',
    'UserDashboard.view_applications': 'View Applications',
    'UserDashboard.viewAccounts': 'View Accounts',
    'UserProfileImageChange.description':
        'All photos must be less than 1024x1024 and will be resized. These photos are public and visible to your entire team.',
    'UserProfileImageChange.new_photo_selected': 'New Photo Selected',
    'UserProfileImageChange.select_new_photo': 'Select New Photo',
    'UserProfileImageChange.success': 'Your profile photo has been updated.',
    'UserProfileImageChange.title': 'Change photo',
    'UserProfileImageChange.title_descriptive': 'Upload New Profile Photo',
    'UserProfileImageChange.upload_new_photo': 'Upload New Photo',
    'Users.accepted': 'Accepted',
    'Users.actions': 'Actions',
    'Users.actions.offboard': 'Offboard {{firstName}} {{lastName}}',
    'Users.actions.offboard.revokeAccess':
        'Revoke access, transfer resource ownership and back up critical data.',
    'Users.actions.offboard.revokeAllSessions': 'Revoke all sessions',
    'Users.actions.offboard.revokeLicenses': 'Revoke licenses',
    'Users.actions.offboard.revokeLicensesText':
        'You will have the authority to revoke active licenses for users. This action will immediately remove access to services associated with the revoked licenses, including Gmail, Drive, and other Google Workspace applications.',
    'Users.actions.onboard': 'Onboard {{firstName}} {{lastName}}',
    'Users.actions.setUpIntegration': 'Set up {{appName}} integration',
    'Users.add_notice':
        'Upon creation, this user will receive a welcome email letting them know how to log-in.',
    'Users.azureSignInCount': 'Entra logins',
    'Users.cloud_activity': 'Users With Cloud Activity',
    'Users.cloud_login': 'Users With Cloud Logins',
    'Users.cloudActivityCount': 'Cloud activity',
    'Users.cloudLoginCount': 'Cloud logins',
    'Users.confirm_disable.text':
        'Disabling this user will block any new application activity from being collected. Information about the user’s application usage and activity will still be retained. The user may also be automatically removed from the active user’s list if they have not submitted any app data within 30 days.',
    'Users.confirm_disable.text.manageUsers':
        'Disabling <bold>{{name}}</bold>, e-mail: <bold>{{email}}</bold>.<br /> <br />Disabling this user will block any new application activity from being collected. Information about the user’s application usage and activity will still be retained. The user may also be automatically removed from the active user’s list if they have not submitted any app data within 30 days.',
    'Users.confirm_disable.title': 'Confirmation to Disable User',
    'Users.confirm_enable.text':
        'If they already have the Auvik SaaS Management agent installed on their devices, it will automatically begin to collect data, if not, you will need to re-install the Auvik SaaS Management agent.',
    'Users.confirm_enable.text.manageUsers':
        'Enabling <bold>{{name}}</bold>, e-mail: <bold>{{email}}</bold>.<br /> <br />If they already have the Auvik SaaS Management agent installed on their devices, it will automatically begin to collect data, if not, you will need to re-install the Auvik SaaS Management agent.',
    'Users.confirm_enable.title': 'Are you sure you want to Enable this User?',
    'Users.confirm_resend.text':
        'Are you sure you want to resend the invitation to <span style="font-weight:600;">{{email}}</span>?',
    'Users.confirm_resend.title': 'Confirm Resend Invitation?',
    'Users.confirm_revoke.text':
        'Are you sure you want to revoke the invitation to <span style="font-weight:600;">{{email}}</span>?',
    'Users.confirm_revoke.title': 'Confirm Revoke Invitation',
    'Users.confirmDisable.subtitle_one':
        'Are you sure you want to disable this user?',
    'Users.confirmDisable.subtitle_other':
        'Are you sure you want to disable {{count}} users?',
    'Users.disable.fail_one': 'Could not disable user.',
    'Users.disable.fail_other': 'Could not disable users.',
    'Users.disable.success_one': 'User disabled successfully.',
    'Users.disable.success_other': 'Users disabled successfully.',
    'Users.email_address': 'Email Address',
    'Users.enable.fail': 'Could not enable user(s).',
    'Users.enable.success': 'User has been enabled.',
    'Users.enter_email_address': 'Enter your Email Address',
    'Users.exclude_disabled': 'Exclude disabled users',
    'Users.exclude_expired': 'Exclude Expired Users',
    'Users.exclude_no_activity': 'Exclude users with no activity',
    'Users.google_login': 'Users With Google Login',
    'Users.googleSignInCount': 'Google logins',
    'Users.identitiesAssets': 'Identities and Assets',
    'Users.last_activity': 'Last Activity',
    'Users.mergeUsers': 'Merge Users',
    'Users.mergeUsers.confirmMergeModal.alert':
        'This process is irreversible and cannot be undone.',
    'Users.mergeUsers.confirmMergeModal.mergeUsersConfirm':
        'Are you sure you want to proceed with the users’ merge?',
    'Users.mergeUsers.confirmMergeModal.mergeUsersInfo':
        'You are about to merge the user <span style="font-weight:600;">{{source}}</span>, the aliases associated with this user, and all data into the user <span style="font-weight:600;">{{target}}</span>. This will result in a single user that consolidates all aliases and associated data. The final user’s name will be <span style="font-weight:600;">{{target}}</span>.',
    'Users.mergeUsers.firstSelectUser': 'Select first the target user.',
    'Users.mergeUsers.mergeModal.info':
        'Choose the "Target User" whose account will remain active once the merge process has been completed. Data from other selected users will be merged into this user.',
    'Users.mergeUsers.moreThanOne': 'You need to select another user.',
    'Users.mergeUsers.noMoreThanTwo': 'You can only merge two users.',
    'Users.mergeUsers.notifyMerge':
        'Merging of the selected users has begun successfully. Completion time may vary based on the amount of data collected. This process will continue in the background if you navigate away from this page.',
    'Users.mergeUsers.notifyMergeFail': 'There was an issue merging the users.',
    'Users.mergeUsers.source': 'Source User',
    'Users.mergeUsers.target': 'Target User',
    'Users.microsoftEntraID.login': 'Users With Microsoft Entra ID Login',
    'Users.newClientNotice':
        'It seems like this is a brand new client account. It may take up to 48 hours for the Identity Manager Integration and Domain Accounts to properly propagate across all accounts.',
    'Users.oktaSignInCount': 'Okta logins',
    'Users.pending': 'Pending',
    'Users.put.notSuccess': 'Unable to put user.',
    'Users.resent_invitation': 'Invitation email has been resent.',
    'Users.revoked_user_successfully':
        'User invitation was revoked successfully.',
    'Users.revokeSessions.accessUserSessions':
        '<span style="font-weight:600;">Access to Users Sessions:</span> You will be granted access to manage and revoke active sessions for the users in Google Workspace. This includes viewing session details and terminating active sessions.',
    'Users.revokeSessions.compliancePolicies':
        "<span style='font-weight:600;'>Compliance with Policies:</span> All actions to revoke sessions must comply with your organization's data privacy and security policies. Ensure that you understand and adhere to these policies to protect sensitive information.",
    'Users.revokeSessions.securityImplications':
        "<span style='font-weight:600;'>Security Implications:</span>  By terminating sessions, you prevent unauthorized access to Google Workspace accounts in case of compromised credentials or devices.",
    'Users.role': 'Role',
    'Users.send_welcome_email': 'Send welcome email',
    'Users.sentInvitation': 'Successfully sent invitation to {{email}}.',
    'Users.sentInvitation.fail': 'Failed to send invitation to {{email}}.',
    'Users.userCount': 'User Count',
    'Users.usersActivity': 'Users Activity',
    'UsersAccountsAndDevices.accountCount': 'Account Count',
    'UsersAccountsAndDevices.accountsTabAria': 'Admin Accounts Tab',
    'UsersAccountsAndDevices.accountsType': 'Accounts Type',
    'UsersAccountsAndDevices.devicesTabAria': 'Admin devices Tab',
    'UsersAccountsAndDevices.discoveredDate': 'Discovered Date',
    'UsersAccountsAndDevices.lastTimeLogin': 'Last Time Login',
    'UsersAccountsAndDevices.numberOfApps': 'Number of Applications',
    'UsersAccountsAndDevices.numberOfUsers': 'Number of Users',
    'UsersAccountsAndDevices.onlyWorkAccounts': 'Only Work Accounts',
    'UsersAccountsAndDevices.providerGroupsTabAria':
        'Admin Provider Groups Tab',
    'UsersAccountsAndDevices.providerUsersTabAria': 'Admin Provider Users Tab',
    'UsersAccountsAndDevices.title': 'Users, Accounts, and Devices',
    'UsersAccountsAndDevices.totalLogins': 'Total Logins',
    'UsersAccountsAndDevices.usersTabAria': 'Admin Users Tab',
    'UsersAndDevices.deploymentHelpWithLink':
        'To deploy devices, view the <Link/>.',
    'UsersAndDevices.title': 'Users & Devices',
    'Utilities.deployment_guide': 'Deployment Guide',
    'Utilities.deployment_guide_description':
        'Read or download the Auvik SaaS Management Documentation for deploying & configuring the Auvik SaaS Management Desktop Agent.',
    'Utilities.deployment_scripts': 'Desktop Deployment Scripts',
    'Utilities.deployment_scripts_description':
        'Deployment scripts for the currently signed in customer. These should only be used if not deployed via a Remote Monitoring & Management tool.',
    'Utilities.manage_users.description':
        'Add/Disable Users & Modify User Permissions',
    'Utilities.Webhooks.description':
        'Configure endpoints to receive data on a schedule or triggered by an event.',
    'VendorIncident.add': 'Add Vendor Incident',
    'VendorIncident.details': 'Vendor Incident Details',
    'VendorIncident.id': 'Vendor Incident ID',
    'VendorIncident.last_90_days': 'Last 90 Days of Vendor Incidents',
    'VendorIncident.list': 'Vendor Incident List',
    'VendorIncident.no_results':
        'We have no documented vendor incidents for this application.',
    'VendorIncident.noImpactedClients': 'No impacting vendor incidents found.',
    'VendorIncident.none_detected': 'None Detected',
    'VendorIncident.numberClientsImpacted_one': '{{count}} Client Impacted',
    'VendorIncident.numberClientsImpacted_other': '{{count}} Clients Impacted',
    'VendorIncident.numberClientsImpacted_zero': 'No Clients Impacted',
    'VendorIncident.onlyImpactedClients': 'Only impacted clients',
    'VendorIncident.overview': 'Vendor Incident Overview',
    'VendorIncident.partner': 'Partner Vendor Incidents',
    'VendorIncident.potential_exposure': 'Potential Exposure',
    'VendorIncident.recent': 'Recent Vendor Incidents',
    'VendorIncident.search_app': 'Search for an available application',
    'VendorIncident.search_app.loading': 'Loading available applications...',
    'VendorIncident.select': 'Select Vendor Incident(s)',
    'VendorIncident.suggested_actions_tooltip':
        'These steps are provided as a convenience and are sourced directly from the software provider.',
    'Webhooks.configure': 'Configure a Webhook',
    'Webhooks.confirm_delete': 'Are you sure you want to delete this Webhook?',
    'Workflow.error_no_client': 'You must choose a Client.',
    ...adminMessages,
    ...alertsMessages,
    ...anmTrialMessages,
    ...commonMessages,
    ...dashboardMessages,
    ...deploymentGuideMessages,
    ...formTranslations,
    ...globalAdminMessages,
    ...integrationMessages,
    ...onboardingMessages,
    ...pathfinderMessages,
    ...reportMessages,
    ...saasOpsMessages,
    ...tableMessages,
    ...tableViewsMessages,
    ...tagsMessages,
    ...tooltipMessages,
    ...userInviteMessages
};

export default messageList;
